import { TFunction } from 'i18next'
import { InfoMessage } from '@types'
import InfoMessages from './InfoMessages'

// Labels are translated at render time: module-level i18n.t() runs before i18n.init().
export const getInfoMessageTypesOptions = (t: TFunction): { label: string; value: InfoMessage['type'] }[] => [
  { label: t('common.alert'), value: 'alert' },
  { label: t('common.webview'), value: 'webview' },
]
export type ButtonType = 'openurl' | 'cancel'

export default InfoMessages
